import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import NotFound from '../../pages/NotFound';

/**
 * Protected route component for worker onboarding flow
 * Only allows access to workers who haven't completed onboarding (isOnboarding: true)
 */
const ProtectedOnboardingRoute = ({ children }) => {
    const { user, loading } = useAuth();

    // Show loading state while checking authentication
    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '60vh',
                fontSize: '18px',
                color: '#666'
            }}>
                Loading...
            </div>
        );
    }

    // Not authenticated - redirect to login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // User is not a worker (regular user or admin) - show 404
    if (user.role !== 'worker') {
        return <NotFound />;
    }

    // Worker has already completed onboarding - redirect to dashboard
    if (user.isOnboarding === false) {
        return <Navigate to="/worker/dashboard" replace />;
    }

    // Worker is in onboarding state - allow access
    return children;
};

export default ProtectedOnboardingRoute;
